import request from 'src/api'
import SignaturePad from 'signature_pad'
import { addToast } from 'src/toasts'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { openDownloadLink } from 'src/download'
import initAutoGrow from 'src/autoGrow'

let prevWidth
let modalCanvas
let modalSignaturePad
let signatureResizeHandler

export default () => {
  initAutoGrow('#quality-controls')

  $('#quality-controls').on('change', 'form input, form select, form textarea, form checkbox, form radio', function(event) {
    dirty = true
  })

  // Show fullscreen loader and lock buttons on any form submit (both buttons + programmatic clicks).
  // Delegated from <header>, where both buttons live, and NOT from document: this function runs on every
  // turbolinks:load, and document survives the visit, so a document listener accumulated one copy per visit
  // (F-83). Offline, that meant N identical "no network" toasts after N visits. <header> is replaced with the
  // body, so this goes with it -- the same container the #sign-out handler in application.js uses.
  // ⚠️ **`#submitForm` only since F-163.** `#saveRecurring` was a second SUBMIT button and belonged here;
  // it is a checkbox now, and ticking a checkbox must not show the fullscreen loader or block on being
  // offline. Leaving it in this selector would have frozen the screen on a tick.
  $('header').on('click', '#submitForm', function(event) {
    if (!navigator.onLine) {
      addToast(I18n.t("errors.no_network"), 'error')
      return event.preventDefault()
    }
    fullscreenLoader.show()
  })

  $('#quality_control_id').on('change', function() {
    const qualityControlId = $(this).val()

    if (qualityControlId) {
      lockButton('#quality_control_id')
      $.getScript('/quality_controls/' + qualityControlId + '/edit')
    }
  })

  $('#quality-controls').on('click', '.quality_control_add_fields', function(event) {
    var regexp, time
    time = new Date().getTime()
    regexp = new RegExp($(this).data('id'), 'g')
    // F-165: a contact person has no accordion of its own any more, so there is nothing to collapse
    // before appending and nothing to open after. The one click that remains opens the contact-PEOPLE
    // section, which is still a section.
    $('#accordionContactPerson').append($(this).data('fields').replace(regexp, time))
    $('#accordionContactPeople .accordion-header').first().find('.accordion-button.collapsed').click()
    $('.quality-control-remove-record.laatu').removeClass('d-none')

    $(this).blur()

    return event.preventDefault()
  })

  $('#quality-controls').on('click', '.quality-control-remove-record', function(event) {
    $(this).closest('.contact_person').find('input[id*="_destroy"]').val('1')
    $(this).closest('.contact_person').addClass('d-none')
    // ⚠️ Removing the FIELDS is what stops the inputs posting for a contact the user deleted — the
    // `_destroy` flag and the two hidden ids sit outside this wrapper on purpose. It was
    // `.accordion-collapse` until F-165 took that element away.
    $(this).closest('.contact_person').find('.contact_person_fields').remove()

    let firstName = $('.contact_person:visible:first input[name*="first_name"]:first').val()
    let lastName = $('.contact_person:visible:first input[name*="last_name"]:first').val()

    $('#quality_control_contact_name').html((firstName || '') + ' ' + (lastName || ''))

    if ($('.contact_person').not('.d-none').length === 1) {
      $('.quality-control-remove-record.laatu').addClass('d-none')
    }

    return event.preventDefault()
  })

  // The rating select sits IN the area's collapsed header row, so tapping it opens the panel behind it.
  // 📌 The contact select was in this list until F-165 and is not any more: its fields are always
  // visible, so there is no header and no button to click — the selector matched nothing.
  $('#quality-controls').on('click', '.laatu-rating', function(event) {
    $(this).closest('h2').find('button.collapsed').click()
  })

  $('#quality-controls').on('change', '.laatu-rating', function(event) {
    let selected = $('#quality-controls #accordionAreas select :selected').map(function(i, el) {
      return parseFloat($(el).val());
    }).get()
    let arr = selected.filter(function(val) {
      return val;
    })
    const average = arr.reduce((a, b) => a + b, 0) / arr.length;

    $('#quality-controls #accordionAreas .avg').html(average.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
  })

  $('#quality-controls').on('change', '.quality_control_select_contact_person', function(event) {
    const id = $(this).val()
    const $cp = $(this).closest('.contact_person')
    $cp.find('input[name*="contact_person_id"]').val(id)
    let firstSelectId = $('.contact_person:visible:first select:first').attr('id')

    if (id) {
      lockButton(event.currentTarget)

      const customerId = $("#quality_control_customer_id").val()
      request.get(`/customers/${customerId}/contact_people/${id}`)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          $cp.find('input[name*="first_name"]').val(res.body.first_name).prop("disabled", res.body.deleted)
          $cp.find('input[name*="last_name"]').val(res.body.last_name).prop("disabled", res.body.deleted)
          $cp.find('input[name*="phone"]').val(res.body.phone).prop("disabled", res.body.deleted)
          $cp.find('input[name*="email"]').val(res.body.email).prop("disabled", res.body.deleted)
          $cp.find('input[name*="title"]').val(res.body.title).prop("disabled", res.body.deleted)

          if (firstSelectId === $(this).attr('id')) {
            $('#quality_control_contact_name').html(res.body.first_name + ' ' + res.body.last_name)
          }

          unlockButton(event.currentTarget)
        })
        .catch(err => {
          handleErrors(err, null)
          unlockButton(event.currentTarget)
        })
    } else {
      $cp.find('input[name*="first_name"]').val('').prop("disabled", false)
      $cp.find('input[name*="last_name"]').val('').prop("disabled", false)
      $cp.find('input[name*="phone"]').val('').prop("disabled", false)
      $cp.find('input[name*="email"]').val('').prop("disabled", false)
      $cp.find('input[name*="title"]').val('').prop("disabled", false)

      if (firstSelectId === $(this).attr('id')) {
        $('#quality_control_contact_name').html('')
      }
    }
  })

  $('#quality-controls').on('change', 'input[type="file"]', function(event) {
    let filenames = []
    $('#quality-controls div.file').each(function() {
      filenames.push($(this).html())
    })
    $('#quality-controls a.file-download').each(function() {
      filenames.push($(this).html())
    })

    const currentInput = $(this)[0]
    const idNr = currentInput.id.split('_').slice(-1)
    const newIdNr = (parseInt(idNr) + 1).toString()
    const newId = currentInput.id.replace('add_files_' + idNr, 'add_files_' + newIdNr)
    const clonedInput = currentInput.cloneNode(false)
    clonedInput.id = newId
    clonedInput.value = ''
    $(clonedInput).insertAfter(currentInput)
    $(this).siblings('label:first').attr('for', newId)

    if (filenames.includes(currentInput.files[0].name)) {
      addToast(I18n.t("errors.duplicate_file"), 'alert', 'laatu')
      $(this).remove()
      return
    }

    $('<div class="row">' +
      '<div class="col-10 file">' + currentInput.files[0].name + '</div>' +
        '<div class="col-2 text-end">' +
          '<a class="remove-file-laatu btn btn-outline-danger text-danger mb-1" data-id="' + currentInput.id + '" data-new="true" href="#"><i class="bi bi-trash"></i></a>' +
        '</div>' +
      '</div>').insertAfter(currentInput)

    // Save immediately after file is selected so it uploads right away.
    $('#submitForm').click()
  })

  $('#quality-controls').on('click', '.remove-file-laatu', function(event) {
    if ($(this).attr('data-new') === 'true') {
      // File not yet saved — just remove from the pending list, no server call needed.
      $('#' + $(this).attr('data-id')).remove()
    } else {
      // Existing saved file — add to remove_files and save immediately.
      const input = $(this).closest('.col-12').find('input[id*="remove_files"]')
      let val = input.val()
      if (val.length) {
        val += ','
      }
      val += $(this).attr('data-id')
      input.val(val)

      $(this).closest('.row').remove()
      $('#submitForm').click()
      return event.preventDefault()
    }

    $(this).closest('.row').remove()

    return event.preventDefault()
  })

  $('.quality_controls.laatu').on('click', '.toast', function(event) {
    $(this).hide()
  })

  $('#quality-controls').on('click', '#sign_user, #sign_contact', function(event) {
    if ($('#accordionContactPeople').length && $('.accordion-item.contact_person:not(.d-none)').length === 0) {
      addToast(I18n.t("errors.missing_contact_person"), 'alert', 'laatu')
      $('.quality_control_add_fields.add_contact_person_laatu').click()
    } else {
      if ($(this).attr("id") === 'sign_user') {
        $('#quality_control_sign').val('user')
      } else {
        $('#quality_control_sign').val('contact')
      }

      $('#submitForm').click()
    }
  })

  $('#quality-controls').on('click', '#download-service-description', function(event) {
    lockButton('#download-service-description')

    const customerId = $("#quality_control_customer_id").val()
    request.get('/customers/' + customerId + '/service_descriptions')
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        setTimeout(() => checkStatusSDDownload(res.body.jobId), 1000)
      })
      .catch(err => {
        handleErrors(err, null)
        fullscreenLoader.hide()
        unlockButton('#download-service-description')
      })
  })

  function signatureConfirm(message, onConfirm) {
    const footer = $('#mainModal .modal-footer')
    const original = footer.html()
    footer.html(
      '<span class="me-auto">' + message + '</span>' +
      '<button id="signature-confirm-no" type="button" class="btn btn-secondary"><i class="bi bi-x"></i> ' + I18n.t("buttons.no") + '</button>' +
      '<button id="signature-confirm-yes" type="button" class="btn btn-danger"><i class="bi bi-check"></i> ' + I18n.t("buttons.yes") + '</button>'
    )
    footer.off('click.signatureConfirm')
    footer.on('click.signatureConfirm', '#signature-confirm-no', function() {
      footer.off('click.signatureConfirm')
      footer.html(original)
    })
    footer.on('click.signatureConfirm', '#signature-confirm-yes', function() {
      footer.off('click.signatureConfirm')
      footer.html(original)
      onConfirm()
    })
  }

  $('#mainModal').on('click', '#signature-pad-modal-clear', function(event) {
    signatureConfirm(I18n.t("signature_modal.confirm_clear"), function() { modalSignaturePad.clear() })
  })

  $('#mainModal').on('click', '#signature-pad-modal-cancel, #signature-pad-modal-close', function(event) {
    signatureConfirm(I18n.t("signature_modal.confirm_cancel"), function() { mainModal.hide() })
  })

  $('#mainModal').on('click', '#signature-pad-modal-save', function(event) {
    if (typeof modalSignaturePad !== 'undefined' && !modalSignaturePad.isEmpty()) {
      let cachedImage = modalSignaturePad.toDataURL("image/png")
      if ($(this).attr("data-modal-user") === 'user') {
        $("#quality_control_signature_data_user").val(cachedImage)
      } else {
        $("#quality_control_signature_data_contact").val(cachedImage)
      }
      mainModal.hide()
      $('#submitForm').click()
    } else {
      addToast(I18n.t("errors.missing_signature"), 'alert', 'laatu')
    }
  })

  // Capture accordion open/closed state before every submit (client-side only —
  // no server round-trip needed; server still controls error-driven opening).
  window._savedAccordionStates = null
  $('#quality-controls').on('submit', 'form', function(event) {
    window._savedAccordionStates = {}
    $('.accordion-button[data-bs-target]').each(function() {
      window._savedAccordionStates[$(this).data('bs-target')] = !$(this).hasClass('collapsed')
    })
  })
}

function checkStatusSDDownload(jobId) {
  request.get(`/background_jobs/${jobId}`)
    .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
    .accept('json')
    .then(res => {
      if (res.body.done === 1) {
        // newTab unconditionally: this one is always the service description PDF, which Active
        // Storage serves inline, so the tab shows it rather than closing itself (F-69).
        openDownloadLink(res.body.error_message, { newTab: true })
        addToast(I18n.t('download.ready'), 'notice', 'laatu')

        fullscreenLoader.hide()
        unlockButton('#download-service-description')
      } else if (res.body.done === -1) {
        const error = I18n.t("errors.unexpected_error") + '<br/>' + res.body.error_message
        addToast(error, 'error')
        fullscreenLoader.hide()
        unlockButton('#download-service-description')
      } else {
        setTimeout(() => checkStatusSDDownload(jobId), 1000); // Poll every 1 seconds
      }
    })
    .catch(err => {
      handleErrors(err, null)
      fullscreenLoader.hide()
      unlockButton('#download-service-description')
    });
}

function resizeSignatureAndCanvas() {
  // if there are no lines drawn, don't need to scale them
  if ($('#mainModal.show').length) {
    if (modalSignaturePad.isEmpty()) {
      // Set initial size
      resizeCanvas();
    } else {
      // Get the current canvas contents
      let lines = modalSignaturePad.toDataURL("image/png");
      
      // Match canvas to window size/device change
      resizeCanvas();

      // Calculate new size
      let currentWidth = $('#signature-pad-wrapper canvas').width();
      let scale = currentWidth / prevWidth;
      prevWidth = currentWidth; // Prepare for next time

      // Load the adjusted canvas contents
      modalSignaturePad.fromDataURL(lines)
    }
  }
};

function resizeCanvas() {
  /** Have to resize manually to keep the canvas the width of the
  *   window without distorting the location of the "pen". */
  
  // I'm not completely sure of everything in here
  const canvas = $('#signature-pad-wrapper canvas')[0];

  const bodyWidth = $('#mainModal .modal-body').width()
  const bodyHeight = $('#mainModal .modal-body').height()
  let w = bodyWidth
  let h = (9 * bodyWidth) / 16
  if (h > bodyHeight) {
    w = (16 * bodyHeight) / 9
    h = bodyHeight
  }
  $('#mainModal #signature-pad-wrapper').innerWidth(w)
  $('#mainModal #signature-pad-wrapper').innerHeight(h)

  // Not sure why we need both styles and props
  canvas.style.width = w + 'px';
  canvas.style.height = h + 'px';
  
  // When zoomed out to less than 100%, for some very strange reason,
  // some browsers report devicePixelRatio as less than 1
  // and only part of the canvas is cleared then.
  let ratio = Math.max(window.devicePixelRatio || 1, 1);
  // This part causes the canvas to be cleared
  canvas.width = canvas.offsetWidth * ratio;
  canvas.height = canvas.offsetHeight * ratio;
  canvas.getContext("2d").scale(ratio, ratio);
  modalSignaturePad.clear()
};

window.openSignatureModal = function() {
  let userName = ''
  const modalUser = $('#quality_control_sign').val()
  
  if (modalUser === 'user') {
    userName = $('#quality_control_user_name').text()
  } else if (modalUser === 'contact') {
    userName = $('#quality_control_contact_name').text()
  }
  userName = userName.trim()

  $('#quality_control_sign').val('')

  $("#mainModal").html('<div class="modal-dialog modal-fullscreen"><div class="modal-content"><div class="modal-header text-center"><h4 class="modal-title w-100 font-weight-bold">' + userName + '</h4><button type="button" id="signature-pad-modal-close" class="btn-close" aria-label="' + I18n.t("buttons.close") + '"></button></div><div class="modal-body d-flex justify-content-center"><div id="signature-pad-wrapper"><canvas></canvas></div></div><div class="modal-footer"><button id="signature-pad-modal-clear" type="button" class="btn btn-danger"><i class="bi bi-trash"></i> ' + I18n.t("buttons.clear") + '</button><button id="signature-pad-modal-cancel" type="button" class="btn btn-secondary"><i class="bi bi-x"></i> ' + I18n.t("buttons.cancel") + '</button><button id="signature-pad-modal-save" type="button" class="btn btn-success" data-modal-user="' + modalUser + '"><i class="bi bi-check"></i> ' + I18n.t("buttons.save") + '</button></div></div></div>')
  mainModal.show()

  modalCanvas = document.querySelector("#mainModal canvas")
  modalSignaturePad = new SignaturePad(modalCanvas)
  prevWidth = $('#signature-pad-wrapper canvas').width();

  setTimeout(resizeSignatureAndCanvas, 0);
  if (signatureResizeHandler) {
    window.removeEventListener("resize", signatureResizeHandler);
    window.removeEventListener("orientationchange", signatureResizeHandler);
  }
  signatureResizeHandler = () => setTimeout(resizeSignatureAndCanvas, 0);
  window.addEventListener("resize", signatureResizeHandler);
  window.addEventListener("orientationchange", signatureResizeHandler);
}
